import React, { useEffect, useState } from "react";
import Cases from "../../../components/cases";

import { useOutletContext } from "react-router-dom";

const CasesList = () => {
  const [refresh, setRefresh] = useState(false);
  const [
    data,
    handleRefreh,
    location,
    search,
    handleSearch,
    searchFilterState,
    handleFilterStateActive,
    entireCasesText,
    handleEntireCasesText,
    handleSetConsultantFilter,
    selectedConsultant,
    consultantsList,
    selectedConsultantName,
  ] = useOutletContext();
  const [list, setList] = useState(data);
  useEffect(() => {
    setList(data);
  }, [data]);
  const handleRefreshByParent = () => {
    setRefresh((pre) => !pre);
    handleRefreh();
  };
  return (
    <Cases
      data={list}
      handleRefresh={handleRefreshByParent}
      search={search}
      handleSearch={handleSearch}
      searchFilterState={searchFilterState}
      handleFilterStateActive={handleFilterStateActive}
      handleEntireCasesText={handleEntireCasesText}
      entireCasesText={entireCasesText}
      handleSetConsultantFilter={handleSetConsultantFilter}
      selectedConsultant={selectedConsultant}
      consultantsList={consultantsList}
      selectedConsultantName={selectedConsultantName}
    />
  );
};

export default CasesList;
